import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ArticleCategoriesComponent} from './article-categories.component';
import {AddArticleCategoryComponent} from './add-article-category/add-article-category.component';

const routes: Routes = [
  {
    path: 'article-categories',
    component: ArticleCategoriesComponent,
    data: {animation: 'article-categories'}
  },
  {
    path: 'article-category/add',
    component: AddArticleCategoryComponent,
    data: {animation: 'article-category/add'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArticleCategoriesRoutingModule { }
